
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'OrderColumnItem',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => ({})
  })columnItemData!: [];

  private settingColumnItem = false

  created() {
    let body = document.documentElement || document.body;
    body.addEventListener('click', (e: any) => {
      if (e.target.id !== 'getColumnItemBtn') {
        this.settingColumnItem = false;
      }
      if (e.target.name === 'tableColumn') {
        this.settingColumnItem = true;
      }
    }, false);
  }

  showHideColumn() {
    this.settingColumnItem = !this.settingColumnItem;
  }

  setColumnItem(val: any) {

  }
}
